import * as React from 'react'

import {
  AttendanceCustomPeriodEmployeeItemFragment,
  AttendanceSidepanelCompensationBlockFragment,
} from 'generated/resources/graphql'

import CompensationOverview from 'modules/attendance/components/ClockIn/TabsBreakdown/CompensationPannel/Overview'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'

interface CompensationTabProps {
  employee: AttendanceCustomPeriodEmployeeItemFragment
  setSelectedCompensationBlocks: React.Dispatch<
    React.SetStateAction<AttendanceSidepanelCompensationBlockFragment[]>
  >
}

export const CompensationTab = ({
  employee,
  setSelectedCompensationBlocks,
}: CompensationTabProps) => {
  const isPartTime = !!employee.referenceContract?.partTime
  const policySettings =
    employee.attendanceEmployeesPolicy?.attendanceEmployeesSettingsConnection?.edges?.[0]?.node
  const { featureAvailability: hasComplementaryHoursFeature } = useAttendanceFeatures(
    'dev_time_tracking_complementary_hours'
  )
  const useComplementaryHoursLabels =
    hasComplementaryHoursFeature && isPartTime && !!policySettings?.enableComplementaryHours

  if (!employee.id) {
    return null
  }

  return (
    <CompensationOverview
      setSelectedCompensationBlocks={setSelectedCompensationBlocks}
      employeeId={employee.id}
      useComplementaryHoursLabels={useComplementaryHoursLabels}
    />
  )
}
